var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLoanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.8889,
    cy: 30.0734,
    rx: 30.4367,
    ry: 30.0339,
    fill: "#920583",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4997 17.5C23.3955 17.5 17.583 23.125 17.583 30C17.583 36.875 23.3955 42.5 30.4997 42.5C37.6038 42.5 43.4163 36.875 43.4163 30C43.4163 23.125 37.6038 17.5 30.4997 17.5ZM27.9163 36.25L21.458 30L23.2793 28.2375L27.9163 32.7125L37.7201 23.225L39.5413 25L27.9163 36.25Z",
    fill: "#920583"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLoanIcon);
export default __webpack_public_path__ + "static/media/AppLoanIcon.9ffa4dff25a42443f51e99e89e00d033.svg";
export { ForwardRef as ReactComponent };